export default __webpack_public_path__ + "static/media/AGC Logo 2025.499af51a.png";